module.exports = __webpack_public_path__ + "img/potential-bottom.8cb85e6a.svg";